<template>
    <IconBase  v-bind="$props" v-on="$listeners">
        <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="currentColor" />
   </IconBase>
</template>

<script>
import IconBase from './iconBase/IconBase.vue'
import iconProps from './iconBase/iconProps.js'

export default {
  components: { IconBase },
  props: {
    ...iconProps,
    height: {
        ...iconProps.height,
        default: 20,
    },
    width: {
        ...iconProps.width,
        default: 20,
    },
    viewBox: {
        ...iconProps.viewBox,
        default: "0 0 21 19",
    }
  },
}
</script>